__turbopack_context__.v({
  "close": "WtSurvey-module-scss-module__XsbXRW__close",
  "content": "WtSurvey-module-scss-module__XsbXRW__content",
  "cta": "WtSurvey-module-scss-module__XsbXRW__cta",
  "headline": "WtSurvey-module-scss-module__XsbXRW__headline",
  "illustration": "WtSurvey-module-scss-module__XsbXRW__illustration",
  "illustrationImage": "WtSurvey-module-scss-module__XsbXRW__illustrationImage",
  "modal": "WtSurvey-module-scss-module__XsbXRW__modal",
  "subtitle": "WtSurvey-module-scss-module__XsbXRW__subtitle",
});
